import Vue from 'vue';
import NavigationShop from './Components/NavigationShop.vue';

export async function initNavigationShop() {
  new Vue({
    el: '.js-NavigationShop',
    template: '<NavigationShop />',
    data: {},
    components: {NavigationShop},
  });
}
